// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 用户手机号登录 POST /auth/mobile/login */
export async function authMobileLoginUsingPOST(
  body: API.MobileLoginReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMobileLoginResp>('/auth/mobile/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 通过用户访问密钥获取调用凭证 POST /auth/secret-login */
export async function authSecretLoginUsingPOST(
  body: API.UserSecretLoginReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultRefreshTokenResp>('/auth/secret-login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 通过RefreshSession登录 POST /auth/session-login */
export async function authSessionLoginUsingPOST(
  body: API.SessionLoginReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultLoginSessionResp>('/auth/session-login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 刷新AccessToken POST /auth/token/refresh */
export async function authTokenRefreshUsingPOST(
  body: API.SessionLoginReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAccessToken>('/auth/token/refresh', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户手机号登录（加密版） POST /auth/v2/mobile-login */
export async function authV2MobileLoginUsingPOST(
  body: API.NewMobileLoginReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultNewMobileLoginResp>('/auth/v2/mobile-login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 微信公众号授权登录 GET /auth/wx-oa-login */
export async function authWxOaLoginUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.authWxOaLoginUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultWxOaLoginResp>('/auth/wx-oa-login', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取微信公众号授权链接 GET /auth/wx-oa-redirect */
export async function authWxOaRedirectUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.authWxOaRedirectUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/auth/wx-oa-redirect', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 微信注册 POST /auth/wx-register */
export async function authWxRegisterUsingPOST(
  body: API.WxRegisterReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultGenerateTokenResp>('/auth/wx-register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
